const SET_APPLICATIONS = "SET_APPLICATIONS";

export const setApplications = (payload) => {
    return {
        type: SET_APPLICATIONS,
        payload,
    };
};

const initialState = {
    currentUserApps: undefined,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case SET_APPLICATIONS:
            if (!action.payload) {
                return {
                    ...initialState,
                };
            }
            return {
                ...state,
                currentUserApps: {
                    ...state.currentUserApps,
                    ...action.payload,
                },
            };

        default:
            return state;
    }
};
